export function ignoreError(fn) {
    try {
        return fn();
    } catch (unused) {
        return null;
    }
}
